import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from "../Button";
import {
  Dialog,
  DialogBody,
  DialogIcon,
  DialogText,
  ContentTextarea,
  ButtonsRow,
  DialogConfirm,
  DialogCancel
} from './styles';

export default function ModalConfirmation({ show, showTitle = true, onConfirm, onCancel, title = '', text, textButtonConfirm, textButtonCancel }) {

  const myRef = useRef();

  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Dialog canShow={show} >
      <DialogBody ref={myRef}>
        {showTitle &&
          <DialogIcon pink={'exclamation'}>
            {/* <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon> */}
            <DialogText>{title || 'Important notice'}</DialogText>
          </DialogIcon>
        }
        <ContentTextarea>
          <p>
            {text || 'Are you sure sure you want to delete this file?'}
          </p>
          <br />
          <ButtonsRow>
            <DialogCancel
              style={{ marginRight: 15 }}
              third
              type="button"
              onClick={() => {
                onCancel && onCancel();
              }}
            >
              {textButtonCancel || 'NO'}
            </DialogCancel>
            <DialogConfirm
              style={{ marginRight: 15 }}
              primary
              type="submit"
              onClick={() => handleConfirm()}
            >
              {textButtonConfirm || 'YES'}
            </DialogConfirm>
          </ButtonsRow>
        </ContentTextarea>
      </DialogBody>
    </Dialog>

  );
}